<template>
  
    <div class="banner-box">
    <!-- //产品分类 -->
    <div class="banner-classify banner">
      <div class="classify-box">
        <div class="banner-t">
        <div class="banner-text">
          <span>产品分类</span>
          <p>Product Category</p>
        </div>
        <div class="banner-more">
          <svg t="1682322386966" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3777" width="200" height="200"><path d="M936.7 488.6l-399.9-0.6 0.5-399.8c0-13.3-10.7-24-24-24-13.2 0-24 10.7-24 24l-0.5 399.8-399.8-0.5c-13.2 0-24 10.7-24 24s10.7 24 24 24l399.8 0.5-0.5 399.9c0 13.3 10.7 24 24 24 13.2 0 24-10.7 24-24l0.5-399.9 399.9 0.5c13.2 0 24-10.7 24-24 0-13.2-10.7-23.9-24-23.9z" p-id="3778" fill="#e6e6e6"></path></svg>
        </div>
      </div>
      <div class="swiper-container1">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(i,index) in data.product_type" :key="index">
          <div class="classify-container-main ">
            <div class="classify-main-t">
              <div class="classify-main-num">0{{ index+1 }}</div>
              <div class="classify-main-img">
                <img :src=imgurl+i.image alt="" />
              </div>
            </div>
            <div class="classify-main-b">
              <div class="c-m">
                <div class="c-m-t">{{i.title}}</div>
                <div class="c-m-b">Secondary antibodies</div>
              </div>
            </div>
            <div class="classify-main-f">
              {{i.Product.title}}
            </div>
          </div>
        </div>
         
        </div>
        <div class="swiper-pagination"></div>
      </div>
      </div>
    </div>
    <!-- //热销产品 -->
    <div class="banner-hot banner">
      <div class="classify-box">
        <div class="banner-t">
        <div class="banner-text">
          <span>热销产品</span>
          <p>Hot Products</p>
        </div>
        <div class="banner-more">
          <svg t="1682322386966" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3777" width="200" height="200"><path d="M936.7 488.6l-399.9-0.6 0.5-399.8c0-13.3-10.7-24-24-24-13.2 0-24 10.7-24 24l-0.5 399.8-399.8-0.5c-13.2 0-24 10.7-24 24s10.7 24 24 24l399.8 0.5-0.5 399.9c0 13.3 10.7 24 24 24 13.2 0 24-10.7 24-24l0.5-399.9 399.9 0.5c13.2 0 24-10.7 24-24 0-13.2-10.7-23.9-24-23.9z" p-id="3778" fill="#e6e6e6"></path></svg>
        </div>
        </div>
        <div class="swiper-container2">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(i,index) in data.hot" :key="index">
          <div class="hot-main-container">
            <div class="hot-main-top">
              <div class="hot-main-t">
                <img :src=imgurl+i.image alt="" />
              </div>
              <div class="hot-main-text">{{i.title}}</div>
            </div>
            <div class="hot-main-tip">
            {{ i.dosage }}
            </div>
          </div>
        </div>
      
        
      
      
        </div>
        <div class="swiper-pagination" v-if="data.hot.length>0"></div>
      </div>
      </div>
    </div>
    <!-- //推荐产品 -->
    <div class="banner-recommend banner">
      <div class="classify-box">
        <div class="banner-t">
        <div class="banner-text">
          <span>推荐产品 </span>
          <p>Hot Products</p>
        </div>
        <div class="banner-more">
          <svg t="1682322386966" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3777" width="200" height="200"><path d="M936.7 488.6l-399.9-0.6 0.5-399.8c0-13.3-10.7-24-24-24-13.2 0-24 10.7-24 24l-0.5 399.8-399.8-0.5c-13.2 0-24 10.7-24 24s10.7 24 24 24l399.8 0.5-0.5 399.9c0 13.3 10.7 24 24 24 13.2 0 24-10.7 24-24l0.5-399.9 399.9 0.5c13.2 0 24-10.7 24-24 0-13.2-10.7-23.9-24-23.9z" p-id="3778" fill="#e6e6e6"></path></svg>
        </div>
        </div>
        <div class="recommend-main">
          <div class="recommend-main-left" v-if="data.publicize">
            <div class="swiper-container5">
              <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(i,index) in data.publicize" :key="index">
            <img :src=imgurl+i.image alt="" />
          </div>
         
            </div>
            <div class="swiper-pagination" v-if="data.publicize.length>0"></div>
            </div>
            
          </div>
          <div class="recommend-main-right">
            <div class="recommend-main-right-t">
              <div class="recommend-right-t-l">
                <div class="text">
                  {{recommend.title}}
                </div>
                <div class="text text-padding">
              {{recommend.descript}}
                </div>
              
              </div>
              <div class="recommend-right-t-r" v-if="recommend.image">
                <img :src=imgurl+recommend.image alt="" />
              </div>
            </div>
            <div class="swiper-container4">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(i,index) in data.recommend" @click="recommend(i)" :key="index">
              <div class="recommend-right-tips recommend-right-tips-hover">
                <div>{{i.title}}</div>
              </div>
              </div>

              
            </div>
          </div>
          </div>
        </div>
        <div class="recommend-main-web">
       <div class="recommend-t">
        <div class="recommend-main-left">
            <img src="../../img/poster.png" alt="" />
           </div>
          <div class="recommend-right-t-r" v-if="recommend.image">
            <img :src=imgurl+recommend.image alt="" />
          </div>
        
       </div>
       <div class="recommend-main-right-t">
              <div class="recommend-right-t-l">
                {{recommend.descript}}
              </div>
            
            </div>
            <div class="swiper-container3">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(i,index) in data.recommend" @click="recommend(i)" :key="index">
              <div class="recommend-right-tips recommend-right-tips-hover">
                <div>{{i.title}}</div>
              </div>
              </div>

             
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- //应用领域 -->
    <div class="banner-territory banner">
      <div class="classify-box">
        <div class="banner-t">
        <div class="banner-text">
          <span>应用领域</span>
          <p>Hot Products</p>
        </div>
        <div class="banner-more" @click="more('APPlication')">
          <svg t="1682322386966" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3777" width="200" height="200"><path d="M936.7 488.6l-399.9-0.6 0.5-399.8c0-13.3-10.7-24-24-24-13.2 0-24 10.7-24 24l-0.5 399.8-399.8-0.5c-13.2 0-24 10.7-24 24s10.7 24 24 24l399.8 0.5-0.5 399.9c0 13.3 10.7 24 24 24 13.2 0 24-10.7 24-24l0.5-399.9 399.9 0.5c13.2 0 24-10.7 24-24 0-13.2-10.7-23.9-24-23.9z" p-id="3778" fill="#e6e6e6"></path></svg>
        </div>
        </div>

        <div class="territory-main">
          <div v-for="(i,index) in data.applicate" :key="index" :class="[tipsNum==index?'territory-container-hover':'']" @click.stop="territory($event,index)">
          <div class="territory-container"  >
           <div class="territory-t">
            <div class="territory-container-logo">
          <img :src=imgurl+i.image1 alt="" class="logoImg">
          <img :src=imgurl+i.image2 alt="" class="logoImg2">
              <div>0{{ index+1 }}</div>
            </div>
            <div class="territory-container-tips" >
             <img src="../../img/select.png"  class="tips-svg">
             <img src="../../img/select2.png" alt="">
            </div>
           </div>
           <img :src=imgurl+i.image alt="" class="territoryBack">
          </div>
        </div>
        </div>
      </div>
    </div>
    <!-- //正熙简介 -->
    <div class="banner-synopsis banner">
      <div class="classify-box">
        <div class="banner-text">
          <span>正熙简介</span>
          <p>Hot Products</p>
        </div>
        <div class="text-main">
          <img src="../../img/synopsis.png" alt="" class="text-main-img" />
          <div class="text-main-banner">
            <div class="text-main-container">
              <div class="text-main-banner-title">
               {{about.title}}
              </div>
              <div class="text-main-banner-container">
               {{about.content}}
              </div>
             
            </div>
          </div>
          <div class="enterprise">
            <img :src=imgurl+about.image alt="" />
            <div class="enterprise-main" @click="more('Introduction')">
              <svg t="1684982072239" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4469" width="200" height="200"><path d="M512 85.333333c235.637333 0 426.666667 191.029333 426.666667 426.666667S747.637333 938.666667 512 938.666667 85.333333 747.637333 85.333333 512 276.362667 85.333333 512 85.333333z m0 234.666667a32 32 0 0 0-32 32v128H352a32 32 0 0 0 0 64h128v128a32 32 0 0 0 64 0V544h128a32 32 0 0 0 0-64H544V352a32 32 0 0 0-32-32z" fill="#144297" p-id="4470"></path></svg>
              <span>企业简介</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
 
</template>
<script>
import Swiper from "swiper";
import {home,system} from '../../request/api'
export default {
  data() {
    return {
        imagelist:['../../img/基因数据.png','../../img/基因排列2.png','../../img/基因结构2.png','../../img/细胞2.png',],
       imagelist2:['../../img/基因数据2.png','../../img/基因排列.png','../../img/基因结构.png','../../img/细胞.png',]
    ,tipsNum:0,
    t:'',
    isScroll:false,
    data:'',
    imgurl:'https://admin.zxbiotech.cn',
    recommend:[],
    about:''
    };
  },
  mounted() {
    home().then((res=>{
    
      this.data=res.data.data
      if(this.data.recommend[0]){
        this.recommend=this.data.recommend[0]
      }
     
      this.$nextTick(()=>{
        this.swiperContainer2()
        this.swiperContainer1()
        this.swiperContainer3()
        this.swiperContainer4()
        this.swiperContainer5()
      })
      
    }))
    system({id:19}).then((res)=>{
      this.about=res.data.data
    })
  
   



  },
  methods: {
    more(i){
      this.$submit.direct(i)
    this.$bus.$emit("hello", i);
      this.$router.push(i)
      document.documentElement.scrollTop=0
      
    },
    swiperContainer1(){
      new Swiper(".swiper-container1", {
  
  slidesPerView: 'auto',
  spaceBetween :'1.1%',
  pagination: {
          el: '.swiper-pagination',
          clickable :true,
          bulletClass : 'my-bullet',
          bulletActiveClass: 'my-bullet-active',
       },

       

});
    },
    swiperContainer2(){
      new Swiper(".swiper-container2", {
  
  slidesPerView: 'auto',
  spaceBetween :'1.1%',
  pagination: {
          el: '.swiper-pagination',
          clickable :true,
          bulletClass : 'my-bullet2',
          bulletActiveClass: 'my-bullet2-active',
       },

       

    });
    },
    swiperContainer3(){
      new Swiper(".swiper-container3", {
  
  slidesPerView: 'auto',

  pagination: {
          el: '.swiper-pagination',
          clickable :true,
          bulletClass : 'my-bullet2',
          bulletActiveClass: 'my-bullet2-active',
       },

       

});
    },
    swiperContainer4(){
      new Swiper(".swiper-container4", {
  
  slidesPerView: 'auto',

  pagination: {
          el: '.swiper-pagination',
          clickable :true,
          bulletClass : 'my-bullet2',
          bulletActiveClass: 'my-bullet2-active',
       },

       

});
    },
    swiperContainer5(){
      new Swiper(".swiper-container5", {
  slidesPerView: 'auto',
 
  pagination: {
              el: '.swiper-pagination',
              clickable :true,
              bulletClass : 'my-bullet',
              bulletActiveClass: 'my-bullet-active',
  },
});
    },
    recommend(i){
      this.recommend=i
    },
    territory(e,n){
      if(this.tipsNum==n){
        this.tipsNum=-1
      }else{
        this.tipsNum=n
      }
      
    },
    pageScroll(){
    //浏览器兼容      
    if ((navigator.userAgent.toLowerCase().indexOf("firefox")!=-1)){   
        document.addEventListener("DOMMouseScroll",this.scrollFun,false);        
    }  
    else if (document.addEventListener) {  
        document.addEventListener("mousewheel",this.scrollFun,false);  
    }  
    else if (document.attachEvent) {  
        document.attachEvent("onmousewheel",this.scrollFun);   
    }  
    else{  
        document.onmousewheel = scrollFun;  
    }  
 
    //滚动事件处理函数
    
    
    },
    scrollFun(event){
         if(this.isScroll){
          return false
         }
    var hei = document.querySelectorAll('.banner')[0].offsetHeight
   
   
    //如果不加时间控制，滚动会过度灵敏，一次翻好几屏
    var startTime = 0, //翻屏起始时间  
        endTime = 0,  
        now = 0; 
        startTime = new Date().getTime();  
        var delta = event.detail || (-event.wheelDelta);  
        //mousewheel事件中的 “event.wheelDelta” 属性值：返回的如果是正值说明滚轮是向上滚动
        //DOMMouseScroll事件中的 “event.detail” 属性值：返回的如果是负值说明滚轮是向上滚动
        if ((endTime - startTime) < -1000){
            if(delta>0  ){
                //向下滚动
                now =   hei;
                this.toPage(now);
               
        } 
            if(delta<0 ){
                //向上滚动
                    now = ( - hei);
                   this.toPage(now);
            }
             endTime = new Date().getTime();  
        }
           else{  
                event.preventDefault();    
            }    
    },
    toPage(now){        
    this.isScroll=true
          startRollToEndTwo()
    
    function startRollToEndTwo(end=0,time = 500){  //变速（匀减速）
    let timer;
    //获取当前毫秒数
    let startTime = +new Date();     
    let start = document.documentElement.scrollTop || document.body.scrollTop;  //初始位置
    //获取从开始到结束需要滚动的长度
    end=start+now
    let length = start - end;
    //假设时间(x)与距离(y)成立xy坐标轴,要想变速那么时间与距离之间的关系：a*x^2 + b*x = y
    //已知两个坐标点,求解ab常量
    const [x1,y1,x2,y2] = [time,length,time*2,0];
    let a = (y1/x1 - y2/x2)/(x1 - x2);
    let b = (y1-a*Math.pow(x1,2))/x1;
    timer = requestAnimationFrame(function func(){
        //获取下一帧的时间距离开始的时间，以此计算此时的位置，如果超过了预计的时间，则就等于参数所规定的时间
        let timeX = time - Math.max(0,startTime - (+new Date()) + time);
        let lengthY = a*Math.pow(timeX,2) + b*timeX;
        document.documentElement.scrollTop = document.body.scrollTop = -lengthY + start;
        timer = requestAnimationFrame(func);
        //如果距离开始时间已经到了规定的时间则不用在执行了
        if(timeX == time){
            cancelAnimationFrame(timer);
        }
    });
    
    }
    setTimeout(() => (this.isScroll = false), 1300);
   //javascript 实现动画效果
    } ,
    
  },
};
</script>
<style  scoped>
@media screen and (min-width: 820px) {
  .territory-container-hover .territory-container{
  width: 13.0625rem !important;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.territory-container-hover div{
  color: #fff !important;
}
.swiper-pagination{
  display: flex;
  width: auto !important;
  bottom: 1.2rem !important;
  right: 3.25rem;
  justify-content: end;
  align-items: center;
}
}

@media screen and (min-width: 300px) and (max-width: 820px){
  .classify-main-num{
    font-size: 14px !important;
  }
  .enterprise-main{
    width: 142px !important;
height: 50px !important;

border-radius: 28px 28px 28px 28px !important;
top: 64px !important;
left: 46px !important;
  }
  .enterprise-main svg{
    height: 40px !important;
    width: 40px !important;
  }
  .enterprise-main span{
    font-size: 20px !important;
  }
  .text-main{
    padding-top: 150px !important;
  }
  .enterprise{
    right: auto !important;
    left: 50%;
    transform: translate(-50%,0);
  }
  .enterprise img{
    width: auto !important;
    height: 177px !important;
    box-shadow: none !important;
  }
  .text-main-img{
    height: 350px !important;
  }
  .text-main-banner{
    top: 200px !important;
    width: 90% !important;
    box-sizing: border-box !important;
    margin-right: -0.6875rem !important;
  }
  .text-main-container{
    width: 100% !important;
  }
  .text-main-banner-title{
    font-size: 18px !important;
  }
  
  .text-main-banner-container {
    line-height: 1.5 !important;
    font-size: 16px !important;
  }
  .text-main-banner-container2{
    font-size: 16px !important;
  }
  .text-main-banner-title{
    width: 100% !important;
  }
  .classify-container-main{
    margin-right: 11px;
    width: 229px !important;
  }
  
  .territory-t{
    height: 60px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .swiper-container2 .swiper-pagination{
    bottom: 120px !important;
  }
  .territory-container-tips img:nth-child(2){
  display: none;
  transform: rotate(180deg) !important;
}
  .swiper-container2{
    margin-right: -30px ;
  }
  .swiper-pagination>>>.my-bullet2{
    width: 65px !important;
height: 1px !important;
background: rgba(217, 227, 239, 1);

  }
  .swiper-pagination>>>.my-bullet2-active{
    width: 65px !important;
height: 3px !important;

background: #144297;

  }
  .swiper-container1{
    margin-right: -30px;
  }
  .swiper-pagination{
    display: flex;
    bottom: 45px !important;
    right: 22px !important;
    justify-content: start;
    width: auto;
    left: auto !important;
    right: 0;
  }
  .swiper-pagination>>>.my-bullet-active{
  
background: #144297 !important;
  }
 .swiper-pagination>>> .my-bullet{
  width: 30px !important;
height: 5px !important;
border-radius: 0;
display: flex;

background: #D9E3EF;
margin-left: 5px;
}
  .territory-container-tips{
    position: relative !important;
    bottom: 0 !important;
    display: flex;
    justify-content: start;
    width: 16px !important;
    margin-right: 22px;
    height: 1.5rem !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .territory-container-tips img{
    width: 16px !important; 
height: 16px !important;
transform: rotate(0deg) !important;
  }
  .territory-container-logo img{
    width: 1.5rem !important;
    height: 1.5rem !important;
  }
  .territory-container-logo div{
    padding-top: 0 !important;
    font-size: 16px !important;
  }
  .territory-container{
    display: flex;
    align-items: start;
    justify-content: space-between;
    
  }
  .web-recommend-b{
    position: relative;
    width: 100%;
    height: 108px;
  overflow: hidden;
  }
  .territory-main{
    flex-direction: column;
  }
  .territory-container{
    width: 100% !important;
    height: 60px !important;
  }
  .territory-container-hover .territory-container {
    height: 188px !important;
   
    
  color: #fff !important;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  }
  .territory-container-logo{
    display: flex;
    align-items: center;
    padding-top: 0 !important;
  }
  .recommend-right-tips{
    width: 200px !important;
height: 108px !important;


  }
  .recommend-right-tips div{
    padding-top: 45px !important;
    font-size: 14px !important;
  }
  .recommend-main-right-b{
    position: absolute;
  }
  .recommend-main-left {
    width: 141px !important;
height: 175px !important;

  }
  .recommend-right-t-r img{
    width: 175px !important;
height: 175px !important;
  }
  .recommend-main-left img{
    width: 141px !important;
height: 175px !important;

  }
  
  .recommend-t{
    display: flex;
    justify-content: space-between;
  }
  .recommend-main-right-t{
    width: 100% !important;
  }
  .recommend-right-t-l{
    margin-top: 29px ;
    font-size: 14px !important;
font-family: 'Alibaba PuHuiTi-Regular';
font-weight: 400;
color: rgba(20,66,151,0.8);
    width: 100% !important;
    line-height: 23px;
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:4;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }
  .recommend-main{
    display: none !important;
  }
  .recommend-main-web{
    display: block !important;
  }
  .hot-box{
    position: relative;
  }
  .hot-main-container{
    width: 238px !important;
  }
  .hot-main-top{
    height: auto !important;
  }
  .hot-main-t{
    width: 229px !important;
    height: 230px !important;
  }
  .hot-main-text{
    
font-size: 16px !important;
  }
  .hot-main-tip{
    
font-size: 14px !important;
  }
  .hot-main-container{
    margin-right: 11px !important;
  }
  .hot-main{
    position: absolute;
  }
 .hot-main-text{
  margin-top: 28px !important;
 }
 .hot-main-tip{
  margin-top: 6px !important;
  padding: 0 !important;
 }
  .classify-box{
    position: relative;
  }
  .classify-box{
    padding-top: 90px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
    box-sizing: border-box;
  }
  .classify-location{
    right: 20px !important;
  }
  .classify-location-default{
  
    width: 30px !important;
    height: 3px !important;
    margin-left: 10px !important;
  }
  .classify-location{
    bottom: 45px !important;
  }
  .banner-text{
    margin-bottom: 20px !important;
  }
  
  .banner-text p{
    margin: 0 !important;
    font-size: 12px !important;
  }
  .banner-t{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .classify-list{
display: flex;
padding-right: 30px !important;
    width: 100%;
    height: 100%;
  }
  .classify-main-t{
    align-items: start;
  }
  .classify-main-img {
    width: 158px !important;
height: 219px !important;
  }
  
  .classify-container{
   
    align-items: start;
  }
  .classify-container-main{
    height: auto !important;
  }
  .classify-main-num{
    height: auto !important;
    width: auto !important;
    font-size: 16px;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 8px;
    padding-right: 8px;
    font-family: 'Alibaba PuHuiTi-Medium';
    font-weight: 500 !important;
    
  }
  .classify-container-main:hover .classify-main-num{
    background: #144297 !important;
    color: #fff !important;
  }
  .c-m-t{
    font-size: 20px !important;
  }
  .c-m-b{
    font-size: 14px !important;
  }
 
  .classify-container-main:hover{
    border: 2px solid #144297 !important;
  }
  .classify-container-main:hover .classify-main-f{
    display: block;
  }
  .classify-main-f{
    font-size: 14px !important;
    margin-top: 10px !important;
    margin-bottom: 16px !important;
  }
  .classify-main-f{
    font-size: 12px !important;
    display: none;
  }
  .banner-more{
    right: 30px !important;
background: #144297;
height: 30px !important;
width: 30px !important;
display: flex !important;
align-items: center;
justify-content: center;
  }
  .banner-more svg{
      height: 20px !important;
      width: 20px !important;
  }
  .banner-text span{
    font-size: 24px !important;
  }
} 
.banner-more:hover{
  cursor: pointer;
}
.text-main-banner-container{
  display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        /*! autoprefixer: off */
         -webkit-box-orient: vertical;
        /*! autoprefixer: on */
        text-overflow: ellipsis;
        overflow: hidden;


}
.territory-container-hover .territoryBack{
 opacity: 1 !important;
}
.territory-container-hover{
  position: relative;
}
.territory-t{
  position: relative;
  z-index: 5;
  height: 100%;
}
.territoryBack{
  opacity: 0;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  transition: all .5s ease;
}
.territory-container-hover .logoImg2{
  display: block !important;
}
.territory-container-hover .logoImg{
  display: none !important;
}

.logoImg2{
  display: none;
}
.banner-text p{
  font-family: Source Han Serif CN-Regular, Source Han Serif CN;
  font-size: 0.2rem;
}
.hot-main-text{
  font-family: 'Alibaba PuHuiTi-Regular';
}
.hot-main-container:hover .hot-main-text{
  font-family: 'Alibaba PuHuiTi-Medium';
}
.hot-main-tip{
  font-family: 'Alibaba PuHuiTi-Regular';
}
.enterprise-main{
  position: absolute;
  top: 2.95rem;
  left: 2.83rem;
  width: 1.78rem;
height: 0.63rem;
background: rgba(255,255,255,0.2);
border-radius: 0.35rem 0.35rem 0.35rem 0.35rem;

border: 1px solid rgba(255,255,255,0.7);
backdrop-filter:blur(10px);
display: flex;
justify-content: center;
align-items: center;
}
.enterprise-main svg{
  height: 0.5rem;
  width: 0.5rem;
}
.enterprise-main span{
  font-size: 0.25rem;
font-family: 'Alibaba PuHuiTi-Regular';
font-weight: 400;
color: #FFFFFF;
}
.enterprise-main:hover{
  cursor: pointer;
}
.swiper-container5 {
  width: 100% ;
  overflow: hidden;
}
.swiper-container5 .swiper-pagination{
  bottom: -0.4125rem;
  left: 50%;
  right: auto;
  transform: translate(-50%,-50%);
}
.recommend-right-tips:hover{
  cursor: pointer;
}
.territory-container{
  margin-right:0.25rem
}
.territory-container-tips img:nth-child(2){
  display: none;
  transform: rotate(90deg);
}
.territory-container-hover .territory-container-tips img:nth-child(1){
  display: none;
}
.territory-container-hover .territory-container-tips img:nth-child(2){
  display: block !important;
}
.recommend-main-right-t{
  justify-content: space-between;
}
.swiper-container4{
  width: 12rem;
  overflow: hidden;
}
.banner-text{
  margin-bottom: 0.6rem;
}
.hot-main-container:hover{
  cursor: pointer;
}
.hot-main-container:hover .hot-main-tip{
  display: block;
}
.hot-main-container:hover .hot-main-text{
  color: #144297;
}
.hot-main-tip{
  display: none;
}
.classify-box{
  position: relative;
  box-sizing: border-box;
}

.swiper-pagination>>> .my-bullet2-active{
  width: 2.71rem ;
height: 0.04rem ;
background: #144297 !important;
display: flex;

}
.swiper-pagination>>> .my-bullet2{
  width: 2.71rem;
height: 1px;
background: rgba(217, 227, 239, 1);
display: flex;

}
.swiper-pagination>>> .my-bullet{
  width: 0.5rem;
height: 0.06rem;

background: #D9E3EF;
display: flex;
margin-left: 0.14rem;
}
.swiper-pagination>>> .my-bullet-active{
  width: 0.5rem;
height: 0.06rem;
background: #144297;
}
.swiper-container2{
  overflow: hidden;
}
.classify-container-main:hover .c-m{
  border-bottom: dashed 1px #144297;
}
.classify-container-main:hover .classify-main-f{
    display: block;
  }
  .classify-main-f{
    display: none;
  }
.swiper-container1{
  overflow: hidden;
  padding-bottom: 10px;
}
.swiper-slide{
  width: auto !important;
}
.banner-more{
  position: absolute;
  right: 2.51rem;
  width: 0.5rem;
height: 0.5rem;
background: #144297;
display: flex;
  align-items: center;justify-content: center;
}
.banner-more svg{
  height: 0.4rem;
  width: 0.4rem;
 
}
.banner{
  height: 100vh;
}
.recommend-main-web{
  display: none;
}

.banner-text{
  margin-bottom: 0.725rem;
}
.banner-text span{
  font-family: 'Alibaba PuHuiTi-Medium';
}


.territory-container:hover{
  cursor: pointer;
}
.banner-box {
  width: 100%;
}
.banner-text {
  color: #144297;
}
.banner-text span {
  font-size: 0.4rem;
  font-weight: 500;
}
.baner-text p {
  font-size: 0.2rem;
}
.banner-classify {
  background: url(../../img/Group119.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
}
.classify-box {
  height: 100%;

  padding-top: 2.2375rem;
  padding-left: 3.25rem;
  padding-right: 3.25rem;
}
.classify-container {
  display: flex;
  justify-content: space-between;
  position: relative;
}
.classify-container-main {
  height: 5.7125rem;
  width: 4.1875rem;
  border: 2px solid #d9e3ef;
  padding: 0.3rem 0rem 0.3rem 0.3rem;
  box-sizing: border-box;
}
.classify-container-main:hover {
  box-shadow: 7px 7px 1px -1px #144297;
  border: 1px solid #144297;
  height: auto;
}
.classify-main-t {
  display: flex;

  justify-content: space-between;
  width: 100%;
}
.classify-main-num {
  height: 0.5375rem;
  width: 0.6625rem;
  background-color: #f0f4f9;
  color: #144297;
  font-size: 0.3rem;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
}
.classify-main-img {
  width: 2.9375rem;
  height: 4.1125rem;
}
.classify-main-img img {
  height: 100%;
  width: 100%;
}
.classify-main-b {
  padding-top: 0.3rem;

  padding-right: 0.3rem;
}
.classify-main-f {
  padding-right: 0.3rem;
  padding-top: 0.3rem;
  color: #144297;
}
.c-m {
  padding-bottom: 0.3rem;
  height: 100%;
  width: 100%;
 
}
.c-m-t {
  font-size: 0.3rem;
  color: #144297;
  font-weight: 500;
}
.c-m-b {
  font-size: 0.2rem;
  color: #144297;
  font-weight: 500;
}
.classify-location {
  display: flex;
  position: absolute;
  right: 0;
  bottom: 0;
}

.classify-location-default {
  margin-left: 0.125rem;
  background: #d9e3ef;
  width: 0.5rem;
  height: 0.0625rem;
}
.classify-location-default:hover {
  cursor: pointer;
}
.classify-location-hover {
  background: #144297 !important;
}
.banner-hot {
  background: url(../../img/Group120.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
}
.hot-main {
  display: flex;
  justify-content: space-between;
}
.hot-main-t {
  width: 4.1875rem;
  height: 4.2125rem;
}
.hot-main-container {
  width: 4.1875rem;
}
.hot-main-container:hover .hot-main-t {
  box-shadow: 7px 7px 1px -1px #144297;
  border: 1px solid #144297;
}
.hot-main-t img {
  height: 100%;
  width: 100%;
}
.hot-main-text {
  color: #728ec1;
  font-size: 0.25rem;
}
.hot-main-top {
  height: 4.85rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  box-sizing: content-box;
}
.hot-main-tip {
  color: #144297;
  font-size: 0.2rem;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 0.375rem;
}
.banner-recommend {
  background: url(../../img/Group121.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
}
.recommend-main {
 
  display: flex;
  justify-content: space-between;
}
.recommend-main-left {
  width: 4.3625rem;
  height: 5.4375rem;
  box-shadow: 7px 7px 1px -1px #144297;
  position: relative;
}
.recommend-main-left-tips {
  position: absolute;
  bottom: -0.4125rem;
  padding-left: 1.2875rem;
  display: flex;
}
.recommend-main-left-tips div {
  width: 0.5rem;
  height: 0.0625rem;
  background: #d9e3ef;
  margin-right: 0.1375rem;
}
.left-tips-hover {
  background: #144297 !important;
}
.recommend-main-left img {
  width: 4.3625rem;
  height: 5.4375rem;
}
.recommend-main-right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.recommend-main-right-t {
  display: flex;
}
.recommend-right-t-l {
  width: 7.65rem;
}
.recommend-right-t-r {
}
.recommend-right-t-r img {
  width: 2.7125rem;
  height: 2.7125rem;
}
.banner-recommend .text {
  width: 7.65rem;
  color: #4368ac;
  font-size: 0.225rem;
  font-family: 'Alibaba PuHuiTi-Regular';
}
.banner-recommend .text-padding {
  padding-top: 0.36725rem;
}
.recommend-main-right-b {
  display: flex;
}
.recommend-right-tips div{
  font-family: 'Alibaba PuHuiTi-Regular';
}
.text-main-banner-title{
  font-family: 'Alibaba PuHuiTi-Medium';
}
.text-main-banner-container{
  font-family: 'Alibaba PuHuiTi-Regular';
}
.text-main-banner-container2{
  font-family: 'Alibaba PuHuiTi-Regular';
}
.recommend-right-tips {
  width: 3.8625rem;
  height: 2rem;

  border-bottom: 1px solid #728ec1;
  box-sizing: border-box;
}
.recommend-right-tips:hover {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(20, 66, 151, 0.1) 100%
  );
  border-bottom: 3px solid #144297;
  color: #144297;
  font-weight: 400;
}
.recommend-right-tips div {
  padding-top: 0.7875rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  font-size: 0.25rem;
  color: #728ec1;
}
.territory-main {
  display: flex;
}
.territory-container {
  height: 7.075rem;
  width: 1.2125rem;
  transition: all 0.5s linear ;
  position: relative;
  border: 1px solid #d9e3ef;
  color: #144297;
 /*  background: url(../../img/territory.png); */
}

.tips-icon {
  transform: rotate(270deg);
}
.territory-container-logo {
  padding-top: 0.5125rem;
  padding-left: 0.35rem;
}
.territory-container-logo img {
  height: 0.5rem;
  width: 0.5rem;
}
.territory-container-logo div {
  padding-top: 0.2875rem;
  font-size: 0.3rem;

  display: flex;
  padding-left: 0.075rem;
}
.territory-container-tips {
  width: 100%;
  position: absolute;
  padding-left: 0.4875rem;
  bottom: 0.5rem;
}
.territory-container-tips img {
  transform: rotate(270deg);
  width: 0.25rem;
  height: 0.25rem;
}
.banner-territory {
  background: url(../../img/Group122.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
}
.text-main {
  position: relative;
  padding-top: 0.5625rem;
}
.text-main-img {
  width: 100%;
  height: 4.925rem;
  position: absolute;
  z-index: 800;
}
.text-main-banner {
  top: 1.325rem;
  left: 0.6875rem;
  position: absolute;
  z-index: 500;
}
.text-main-container {
  width: 7.8875rem;
  font-size: 0.225rem;
  font-weight: 400;
  color: #4368ac;
}
.text-main-banner-container {
  line-height: 0.45rem;
}
.text-main-banner-container2 {
  padding-top: 0.45rem;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-main-banner-title {
  font-size: 0.3rem;
  font-weight: 500;
  color: #144297;
  padding-bottom: 0.3875rem;
}
.enterprise {
  position: absolute;
  z-index: 999;
  top: -0.7375rem;
  right: -2.5rem;
}
.enterprise img {
  border-radius: 10px 0px 10px 0px;
  width: 8.5rem;
  height: 4.7875rem;
  box-shadow: -10px 10px 1px -1px #d9e3ef;
}
.banner-synopsis {
  background: url(../../img/Group123.png) ;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
}
</style>>





// WEBPACK FOOTER //
// src/components/banner/banner.vue